import { render } from "./BackgroundsView.vue?vue&type=template&id=d836a6ae&scoped=true"
import script from "./BackgroundsView.vue?vue&type=script&lang=js"
export * from "./BackgroundsView.vue?vue&type=script&lang=js"

import "./BackgroundsView.vue?vue&type=style&index=0&id=d836a6ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d836a6ae"]])

export default __exports__